import styled from 'styled-components'
import { Separator, Text } from '@sketch/components'

export const Callout = styled(Text.Div).attrs({
  textStyle: 'copy.primary.standard.D',
})`
  padding: 16px;
  margin-top: 12px;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  background-color: ${({ theme }) => theme.colors.sketch.F};
  border-radius: ${({ theme }) => theme.radii.xxlarge};
`

export const StyledSeparator = styled(Separator)`
  margin: 24px 0;
`
